import { render, staticRenderFns } from "./yi-loading.vue?vue&type=template&id=1dd318af&"
import script from "./yi-loading.vue?vue&type=script&lang=js&"
export * from "./yi-loading.vue?vue&type=script&lang=js&"
import style0 from "./yi-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/components/yi-loading/yi-loading.vue"
export default component.exports